import React from "react";
import { Link } from "react-router-dom";
import FAQSection from "../components/FAQSection";

const Support = () => {

    const faqs = [
  {
    question: "How do I save books offline?",
    answer: "There are two ways to do it:",
    images: [],
    subQuestions: [
      {
        question: "Option 1. ",
        answer: "Once you have purchased a book, the book will be downloaded and open automatically.",
        images: [],
        subQuestions: [],
      },
      {
        question: "Option 2. ",
        answer: "For some reason, the book is not downloaded automatically. Just tap 'All Books' at the bottom of the App and choose 'Purchased' tab on the top. All books that you have purchased or published will be listed here. Tap the book and download it.",
        images: [process.env.PUBLIC_URL + "/images/faqs/download_a_book.png"],
        subQuestions: [],
      },
    ],
  },
  {
    question: "Why can’t I log in?",
    answer: "Check your internet connection first. If that’s fine, try resetting your password. Still having trouble? Contact support via the Contact Us section below.",
    images: [],
    subQuestions: [],
  },
  {
    question: "How can I delete my account?",
    answer: "Click the User on the top right corner → Delete Account is right at the bottom. Follow the confirmation steps to permanently remove your data.",
    images: [
      process.env.PUBLIC_URL + "/images/faqs/delete_account_step1.png",
      process.env.PUBLIC_URL + "/images/faqs/delete_account_step2.png",
    ],
    subQuestions: [],
  },
  {
    question: "How do i restore my purchase?",
    answer: "Click top left corner menu → Restore Purchases at the bottom.",
    images: [
      process.env.PUBLIC_URL + "/images/faqs/restore_purchase_step1.png",
      process.env.PUBLIC_URL + "/images/faqs/restore_purchase_step2.png",
    ],
    subQuestions: [],
  },
  
];

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>📖 BookEcho Support</h1>
      <p style={styles.intro}>
        Welcome to BookEcho Support! We're here to help you read, explore, and enjoy books.
      </p>

      {/* <section style={styles.section}>
        <h2>💡 Frequently Asked Questions</h2>
        <ul style={styles.list}>
          <li>How do I save books offline?</li>
          <li>Why can’t I log in?</li>
          <li>How can I delete my account?</li>
          <li>Can I restore my purchased books?</li>
        </ul>
      </section> */}

      <FAQSection faqs={faqs} />

      <section style={styles.section}>
        <h2>📬 Contact Us</h2>
        <p>
          If you still need help, please email us at{" "}
          <a href="mailto:joezhuang.au@gmail.com" style={styles.link}>
            joezhuang.au@gmail.com
          </a>
        </p>
      </section>

      <section style={styles.section}>
        <h2>🔒 Privacy Policy</h2>
        <p>
          You can read our{" "}
          <Link
          to="/policy"
          style={{ color: "#3E7DCA", textDecoration: "underline" }}
        >
          Privacy Policy
        </Link>
          .
        </p>
      </section>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "800px",
    margin: "40px auto",
    padding: "20px",
    fontFamily: "'Inter', sans-serif",
    lineHeight: 1.6,
  },
  title: {
    fontSize: "2rem",
    color: "#3E7DCA",
  },
  intro: {
    marginBottom: "20px",
    color: "#444",
  },
  section: {
    marginTop: "30px",
  },
  list: {
    marginLeft: "20px",
  },
  link: {
    color: "#3E7DCA",
    textDecoration: "none",
  },
};

export default Support;
